// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T8JU","newExpiryDate":"styles_newExpiryDate__3ySxh","footer":"styles_footer___VvVd"};